import { FormattedMessage, injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { AutoDismissFlag } from '@atlaskit/flag';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import SimpleTag from '@atlaskit/tag/simple-tag';
import { token } from '@atlaskit/tokens';

import {
  DeleteBranchErrorType,
  DeleteBranchErrorTypes,
  getDeleteBranchDialogSlice,
} from 'src/redux/branches';
import { BucketState } from 'src/types/state';

import { messages } from './delete-branch-error-flag.i18n';

const getErrorMessage = (errorType: DeleteBranchErrorType) => {
  switch (errorType) {
    case DeleteBranchErrorTypes.BRANCH_NOT_FOUND:
      return messages.deleteBranchErrorDescriptionNotFound;
    case DeleteBranchErrorTypes.ACCESS_DENIED:
      return messages.deleteBranchErrorDescriptionAccessDenied;
    default:
    case DeleteBranchErrorTypes.GENERIC:
      return messages.deleteBranchErrorDescriptionGeneric;
  }
};

type Props = {
  id: string;
  branchName: string;
  errorType: DeleteBranchErrorType;
  intl: IntlShape;
};

const ErrorFlag = ({ branchName, errorType, intl, ...otherProps }: Props) => (
  <AutoDismissFlag
    {...otherProps}
    icon={
      <StatusErrorIcon
        spacing="spacious"
        label="error"
        color={token('color.icon.danger')}
      />
    }
    title={intl.formatMessage(messages.deleteBranchErrorTitle)}
    description={
      <FormattedMessage
        {...getErrorMessage(errorType)}
        values={{ branchLabel: <SimpleTag text={branchName} /> }}
      />
    }
  />
);

const mapStateToProps = (state: BucketState) => {
  const {
    errorFlag: { branchName, errorType },
  } = getDeleteBranchDialogSlice(state);

  return {
    branchName,
    errorType,
  };
};

export const DeleteBranchErrorFlag = compose<any, any, any>(
  injectIntl,
  connect(mapStateToProps)
)(ErrorFlag);
